import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/nhan-su/hop-dong'

// Lọc hợp đồng
export function locHopDong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-hop-dong`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy hợp đồng nhân viên
export function layHopDongNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/hop-dong`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy hợp đồng đang hoạt động nhân viên
export function layHopDongDangHoatDongNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/hop-dong/hoat-dong`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy phụ lục hợp đồng
export function layPhuLucHopDong(contractId: number) {
  try {
    return axiosApi.get(`${BASE}/hop-dong/${contractId}/phu-luc`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo hợp đồng nhân viên
export function taoHopDongNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-hop-dong-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật hợp đồng nhân viên
export function capNhatHopDongNhanVien(contractId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${contractId}/cap-nhat-hop-dong-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa hợp đồng nhân viên
export function xoaHopDongNhanVien(contractId: number) {
  try {
    return axiosApi.delete(`${BASE}/${contractId}/xoa-hop-dong-nhan-vien`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo phụ lục hợp đồng
export function taoPhuLucHopDong(contractId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/hop-dong/${contractId}/tao-phu-luc`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật phụ lục hợp đồng
export function capNhatPhuLucHopDong(amendmentId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/phu-luc/${amendmentId}/cap-nhat-phu-luc`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa phụ lục hợp đồng
export function xoaPhuLucHopDong(amendmentId: number) {
  try {
    return axiosApi.delete(`${BASE}/phu-luc/${amendmentId}/xoa-phu-luc`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
